export class UIdModel {
  public constructor(uid:string) {
    this.uId=uid;
  }

  public Id?: string;
  public uId: string;
  public BuyFactorDetailId?: string;
  public count?:number;
  public active:boolean=true;
}